import React from "react";

export default function Preferences() {
  return <div className="headline">Konfiguration</div>;
}
